import React from 'react';
import definicoescliente from '../../definicoes-cliente.json';

const DadosHero = {
    titulo: 'Proteção Veicular',
    descricao: 'Garanta a segurança do seu veículo com nossa assistência e planos personalizados. Confie em quem entende de proteção!',
    textoBotao: 'Cotação Online',
    imagemSrc: '/images/hero3img.png',
}

const ImagemTexto: React.FC = () => {
  return (
    <div className="flex flex-col md:flex-row items-center bg-theme-primary justify-center w-full p-6 pt-32 mx-auto gap-8 lg:px-14">
      
      {/* Texto */}
      <div className="w-full md:w-1/2 md:p-12 text-center md:text-start md:ml-6 mt-6 md:mt-0">
        <h2 className="text-3xl xl:text-5xl text-theme-light-primary font-bold mb-4">
          {definicoescliente?.Hero?.Titulo || DadosHero.titulo}
        </h2>
        <p className="text-theme-light-primary max-w-xl lg:text-lg mb-6">
          {definicoescliente?.Hero?.Descricao || DadosHero.descricao}
        </p>
        <button className="uppercase text-textopadrao bg-theme-secondary px-6 py-2 text-theme-light-secondary rounded shadow-md hover:filter hover:brightness-90 border-2 border-transparent hover:brightness-90 cursor-pointer transition duration-200">
          <a href={definicoescliente.Hero.LinkBotao || "#download"} target="_blank" rel="noopener noreferrer">{definicoescliente?.Hero?.NomeBotao || DadosHero.textoBotao}</a>
        </button>
      </div>

      {/* Imagem */}
      <div className="w-full md:w-1/2 flex justify-center md:ml-6 mt-6">
        <img 
          src={definicoescliente?.Hero?.Imagem || DadosHero.imagemSrc} 
          className="md:flex w-[275px] ml-4 lg:w-[400px] mb-4"
          alt="Descrição da imagem"/>
      </div>
    </div>
  );
};

export default ImagemTexto;
